import Reflux from 'reflux';

const AvailableEventDefinitionTypesActions = Reflux.createActions({
  get: { asyncResult: true },
});

export default AvailableEventDefinitionTypesActions;
